import NotPay from "@/pages/inadimplencia/index.vue";

const routes: Route[] = [
  {
    path: "/inadimplencia",
    name: "notpay.index",
    component: NotPay,
    meta: {
      checkPathDisabled: true
    }
  }
];

export default routes;
